var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgFa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 11,
    viewBox: "0 0 28 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19588 0H28V11H0L4.19588 0Z",
    fill: "url(#paint0_linear_2273_1026)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9142 2.78281H14.2618L13.4945 4.68194H15.1727L14.7278 5.78312H13.0496L11.7987 8.87917H10.4992L12.9623 2.78281H12.3168L13.2265 1.68164H16.8238L15.9142 2.78281Z",
    fill: "#3AF2FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6468 8.87917L17.3922 2.78281H16.807L17.7166 1.68164H19.5153L18.1306 8.87917H16.8311L17.1897 7.26731H15.8815L14.9377 8.87917H13.6468ZM17.4334 6.17411L17.9832 3.6845L16.5212 6.17411H17.4334Z",
    fill: "#3AF2FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2273_1026",
    x1: 25.6667,
    y1: 5.5,
    x2: 2.33333,
    y2: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFa);
export default __webpack_public_path__ + "static/media/bg_fa.4002bdad46ff0d9e83cdc2ffbcee2f96.svg";
export { ForwardRef as ReactComponent };